var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { key: "tool_" + _vm.refresh, attrs: { slot: "tool" }, slot: "tool" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _vm._v(" \n      "),
            !_vm.$root.modeEdit && _vm.canEdit()
              ? _c(
                  "div",
                  [
                    _c("Workflow", {
                      attrs: { affaire: _vm.affaire, ecran: "budget_affaire" },
                      on: { handleAction: _vm.handleMixinAction }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "printer" } },
        [
          _c(
            "div",
            { staticStyle: { display: "none" }, attrs: { id: "print-header" } },
            [
              _c(
                "el-row",
                { staticClass: "btn-back" },
                [
                  _c("el-col", { attrs: { span: 5 } }, [
                    _vm._v("Budget affaire")
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 14, align: "center" } }, [
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(" " + _vm._s(_vm.periodeGestion()) + " ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 5, align: "right" } }, [
                    _vm._v(" ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 5, align: "left" } }, [
                    _c("h2", { staticClass: "numAffaire" }, [
                      _vm._v(_vm._s(_vm.affaire.affaire.num_affaire))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 14, align: "center" } }, [
                    _c("h2", { staticClass: "nomAffaire" }, [
                      _vm._v(_vm._s(_vm.affaire.affaire.nom))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 5, align: "right" } }, [
                    _vm._v(_vm._s(this.$store.getters.affaire.societe.name))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SyncScrollBars",
            [
              _vm._l(_vm.affaire.lots, function(lot, index) {
                return _c(
                  "el-row",
                  { key: lot.id + "_" + _vm.refresh },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 22 } }, [
                          _c("h1", { staticStyle: { "margin-top": "10px" } }, [
                            _vm._v(
                              "Lot " +
                                _vm._s(index + 1) +
                                " " +
                                _vm._s(lot.libelle)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "padding-top": "4px",
                              "white-space": "nowrap"
                            },
                            attrs: { span: 2 }
                          },
                          [
                            _vm.canEdit() &&
                            !_vm.$root.modeEdit &&
                            _vm.userCanDoAction
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "can",
                                        rawName: "v-can:budget_affaire",
                                        value: "editer",
                                        expression: "'editer'",
                                        arg: "budget_affaire"
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "Éditer le contenu du lot",
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-s-tools"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleModeEdit(lot)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("LotDetail", {
                          key: _vm.refresh,
                          attrs: { idLot: lot.id }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "el-row",
                { key: "row_" + _vm.refresh },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [_c("AffaireTotaux", { key: "Totaux_" + _vm.refresh })],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }